import { axiosInstance } from './httpClient';
import { API } from './env';

export default class BonusesApi {
  static getAuthConfig = () => {
    let userInfo = JSON.parse(localStorage.getItem('user'));
    let accessToken = userInfo.token;

    return {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };
  };

  static getBonuses = (companyId) => {
    const query = companyId ? `?companyId=${companyId}` : '';
    return axiosInstance.get(`${API}/admin/bonuses${query}`, this.getAuthConfig());
  };

  static createBonus = (data) => {
    return axiosInstance.post(
      `${API}/admin/bonuses`,
      JSON.stringify(data),
      this.getAuthConfig(),
    );
  };

  static updateBonus = (id, data) => {
    return axiosInstance.patch(
      `${API}/admin/bonuses/${id}`,
      JSON.stringify(data),
      this.getAuthConfig(),
    );
  };
}
